/**
 *
 * Video Popup
 *
 * UI that handles the functionality of opening Youtube videos in a popup
 */

const $ = require('jquery');

var VideoPopup = function (el) {

  //setup some variables
  this.$el = $(el);

  this.init();

};

VideoPopup.prototype.init = function () {

  this.event__playVideo(this);

};

VideoPopup.prototype.event__playVideo = function (event) {

  //open fancybox
  window.jQuery.fancybox.open({
    src: this.$el.attr('href'), // Source of the content
  });

  //update the hash
  if (history.pushState) {
    history.pushState(null, null, `#${this.$el.attr('id')}`);
  } else {
    location.hash = `#${this.$el.attr('id')}`;
  }

};

$(document).ready( () => {

  $('body').on('click', '.js-video-popup', function(e) {
    e.preventDefault();
    new VideoPopup(this);
  });

} );
